
import { Component, Input, OnInit, OnChanges, Output, SimpleChanges, EventEmitter, ViewChild, OnDestroy, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';

import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';

import { NgArrayPipesModule } from 'ngx-pipes';
import { ByWordPipe } from '@shared/filters/by-word/by-word.pipe';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { FormsModule } from '@angular/forms';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipLawComponent } from '../tooltip-law/tooltip-law.component';
import { TooltipInfoComponent } from '../tooltip-info/tooltip-info.component';
import { NgClass, NgStyle } from '@angular/common';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { SpanTooltipComponent } from '@shared/components/span-tooltip/span-tooltip.component';
import { UserPermisionsFactory } from '@shared/factories/user-permisions/user-permisions.factory';
import { BroadcastService } from '@shared/services/broadcast/broadcast.service';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { TooltipInReportComponent } from "../tooltip-in-report/tooltip-in-report.component";
import { ListInDropdownComponent } from "../list-in-dropdown/list-in-dropdown.component";
import { ButtonWithTextMenuArrowComponent } from "../button-with-text-menu-arrow/button-with-text-menu-arrow.component";

@Component({
  selector: 'field-type-contacts',
  templateUrl: './field-type-contacts.component.html',
  standalone: true,
  imports: [
    NgClass,
    NgStyle,
    TooltipInfoComponent,
    TooltipLawComponent,
    TooltipModule,
    AfTranslateDirective,
    FormsModule,
    AfOrderByPipe,
    AfTranslatePipe,
    ByWordPipe,
    NgArrayPipesModule,
    OverlayPanelModule,
    SpanTooltipComponent,
    TooltipInReportComponent,
    ListInDropdownComponent,
    ButtonWithTextMenuArrowComponent
  ]
})
export class FieldTypeContactsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  isLanding = this.customLanding.isLanding();
  subscribers: any = {};
  fieldTypeContacts: any = {
    canCreateContacts: this.configureUserPermisionsCreate(),
    byWord: ['fullName'],
    afOrderBy: ['typeOrder', 'fullName'],
    markAll: false,
    option: '',
    searchName: '',
    selectAssists: undefined,
    showSigned: false,
    titleField: '',
    all: 0,
    pending: 0,
    confirm: 0,
    cancel: 0,
    showToggleAll: false,
    selectedView: {},
    selectedSign: {},
    contactListSelected: [],
    allUsersList: [],
    participantList: [],
    evaluationTaskShares: [],
    typeView: [],
    typeViewItem: {
      keyName: 'label',
      maxWidth: '150px',
      overlayInner: true,
      fixedWidth: true,
    },
    stateContacts: [
      {
        name: this.translate.instant('contacts.state-all'),
        id: 'all'
      },{
        name: this.translate.instant('contacts.state-confirm'),
        id: 'confirm'
      },{
        name: this.translate.instant('contacts.state-cancel'),
        id: 'cancel'
      },{
        name: this.translate.instant('contacts.state-pending'),
        id: 'pending'
      }
    ],
  };

  constructor(private route: ActivatedRoute,
    private apiService: ApiServiceService,
    private broadcastService: BroadcastService,
    private commonUtilsService: CommonUtilsService,
    private modalService: ModalServiceService,
    private translate: AfTranslateFactory,
    private context: ContextFactory,
    private customLanding: CustomLandingFactory,
    private userPermisions: UserPermisionsFactory
  ) {}

  @Input() field : any ={};
  @Input() concept : any ={};
  @Input() valueId : any = null;
  @Input() listDisabled : any ={};
  @Input() selectContextUser: boolean = false;
  @Input() resetCallsInput: boolean = false;
  @Output() openRelatedInfo = new EventEmitter();
  @Output() contactsClosed = new EventEmitter();
  @Output() sendContacts = new EventEmitter();
  @Output() resetCallsEmit = new EventEmitter();
  @ViewChild('containerFieldContact') containerFieldContactElement: ElementRef;
  @ViewChild('fieldTypeContactsContainerParticipants') fieldTypeContactsContainerParticipantsElement: ElementRef;
  @ViewChild('fieldTypeContactsOverlay') fieldTypeContactsOverlay: OverlayPanel;
  @ViewChild(ListInDropdownComponent) listInDropdownComponent: ListInDropdownComponent;

  ngOnInit(): void {
    this.launchWatchers();
    this.field.id = this.field.fieldId? this.field.fieldId : this.commonUtilsService.createId();
    // if(this.field.selectContacts && this.field.typeConfiguration === 'meeting') {
    //   this.configureAssists();
    // }
    this.configureHeaderField();
    if(this.field.callEvaluationTaskShares){
      this.configureEvaluationTaskShares();
    }else{
      this.configureCalls();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['valueId'] && changes['valueId'].previousValue && changes['valueId'].previousValue !== changes['valueId'].currentValue){
      this.resetCalls();
    }

    if(changes['resetCallsInput'] && changes['resetCallsInput'].currentValue){
      this.resetCallsEmit.emit();
      if(!changes['resetCallsInput'].firstChange){
        this.fieldTypeContacts.contactListSelected = this.field.selectContacts;
        this.fieldTypeContacts.typeView = [];
        this.fieldTypeContacts.allUsersList = [];
        this.configureCalls();
      }
    }
    this.configureDisabledList();
    this.fieldTypeContacts.option =  this.field.optionType;

    if(this.field.inReport !== null && this.field.inReport !== undefined){
      this.fieldTypeContacts.inReport = this.field.inReport.indexOf('|') === -1? [this.field.inReport] : this.field.inReport.split('|')
    }
  }

  ngAfterViewInit(): void {
    this.commonUtilsService.bindScrollOverlayListener(this.fieldTypeContactsOverlay);
  }

  configureUserPermisionsCreate(){
    let userPermisions = this.userPermisions.getTypePermissions();
    if(userPermisions === 'admin'){
      return true;
    }
    return false;
  }

  launchWatchers(){
    this.subscribers.resetFieldContactBroadcast = this.broadcastService.subscribe('resetFieldContact', (data:any) => {
        if(this.field.id === data.field.id){
          this.fieldTypeContacts.contactListSelected = [];
          this.resetLists();
          this.sendContacts.emit({contacts:this.fieldTypeContacts.contactListSelected});
        }
    });
    this.subscribers.resetFieldRoleBroadcast = this.broadcastService.subscribe('resetFieldRole', (data:any) => {
        if(this.field.id === data.field.id){
            this.fieldTypeContacts.contactListSelected = this.field.selectContacts;
            this.resetLists();
            this.checkSelectContact();
        }
    });
  }

  configureDisabledList(){
    if(this.listDisabled?.length && this.fieldTypeContacts.allUsersList?.length){
      this.setDisabledContacts(this.fieldTypeContacts.allUsersList);
    }
  }

  configureHeaderField(){
    if(this.field){
      this.fieldTypeContacts.titleField = this.field.label?this.field.label:this.translate.instant('common.users-contacts');
      if(this.field.extendedLabel && this.field.extendedLabel !== ''){
        this.fieldTypeContacts.titleField = this.field.extendedLabel && this.field.extendedLabel !== ''? this.field.extendedLabel : this.field.label;
      }
      this.field.noEditable = this.field.noEditable?this.field.noEditable:false;
    }
  }

  resetCalls(){
    this.fieldTypeContacts.contactListSelected = [];
    this.fieldTypeContacts.allUsersList = [];
    this.field.selectContacts = [];
    this.sendContacts.emit({contacts:this.fieldTypeContacts.contactListSelected});
    this.configureCalls();
  }

  resetLists(){
    this.fieldTypeContacts.allUsersList.forEach((participant: any) => {
      participant.active = false;
    })
  }

  configureCalls(){
    if(this.field.selectContacts && this.field.typeConfiguration === 'meeting'){
      this.configureAssists();
    }
    if(!this.valueId && this.concept && this.concept.productId === 'blanqueo' && this.concept.conceptNamedKey === 'Cliente'){
      this.fieldTypeContacts.option = 'Client';
      this.valueId = this.concept.clientId;
    }else if(!this.valueId && this.concept && this.concept.evaluationId) {
      this.valueId = this.concept.evaluationId;
    }else if(!this.valueId && this.route.snapshot.params['evaluationId']) {
      this.valueId = this.route.snapshot.params['evaluationId'];
    }else if(!this.valueId && this.route.snapshot.firstChild?.params['evaluationId']) {
      this.valueId = this.route.snapshot.firstChild?.params['evaluationId'];
    }
    this.fieldTypeContacts.originalValueId = this.valueId;
    if (this.context.user.companyId || (this.context.user.email && (this.context.user.userId || this.context.user.contactId))) {
      if (this.field && this.field.typeCall.indexOf('contacts') !==-1) {
        this.getContacts();
      } else if (this.field && this.field.typeCall === 'users-only') {
        this.getUsers();
      } else if (this.field && this.field.typeCall === 'users') {
        this.getRolesUsers();
      } else if (this.field && this.field.typeCall === 'groups') {
        this.getGroups();
      }
    }
  }

  configureEvaluationTaskShares(){
    this.apiService.get('conceptobjects/'+this.concept.conceptObjectId+'/evaluation-tasks-shares')
      .then((data: any)=> {
        this.fieldTypeContacts.evaluationTaskShares = data;
        if(this.field.typeConfiguration === 'shareFieldContainer' && this.field.parentId){
          this.configureContainerShare();
        }else{
          this.configureCalls();
        }
      }, (errorData:any)=>{});
  }

  configureContainerShare(){
    this.apiService.get('fieldcontainers/' + this.field.parentId + '/conceptobject/' + this.concept.conceptObjectId + '/shares')
      .then((data: any)=> {
        this.fieldTypeContacts.evaluationTaskShares = this.fieldTypeContacts.evaluationTaskShares.concat(data);
        this.configureCalls();
      }, (errorData:any)=>{});
  }

  getGroups(){
    let url = 'usersgroups';
    if(this.valueId){
        if(this.concept && this.concept.productId === 'blanqueo' && this.concept.conceptNamedKey === 'Cliente'){
          url = 'usersgroups/byproductclientId/' + this.concept.productId + '/' + this.valueId;
        }else if(this.fieldTypeContacts.option === 'Client') {
          url = 'usersgroups/byclientid/' + this.valueId;
        }else{
          url = 'usersgroups/byevaluationid/' + this.valueId;
        }
    }else if(this.concept && this.concept.productId === 'blanqueo' && this.concept.conceptNamedKey === 'SujetoObligado'){
      url = 'usersgroups/byproductclientId/' + this.concept.productId;
    }
    let that = this;
    this.apiService.get(url)
      .then((data: any)=> {
        data.map(function (obj: any) {
          obj.type = 'G';
          obj.typeItem = 'group';
          obj.typeOrder = 1;
          obj.uniqueValueId = 'G-'+obj.groupId;
          if(that.fieldTypeContacts.evaluationTaskShares?.length){
            that.configureItemDisabled(obj, 'groupId');
          }
          return obj;
        });
        this.fieldTypeContacts.allUsersList = this.fieldTypeContacts.allUsersList.concat(data);
        if(data?.length){
          let state: any = {
            type: 'group',
            label: this.translate.instant('contacts.groups'),
            optionAction: 2,
            order: 2,
          }
          this.fieldTypeContacts.typeView.push(state);
        }
        this.getContacts();
      }, (errorData:any)=>{});
  }

  configureItemDisabled(item: any, typeId: any){
    this.fieldTypeContacts.evaluationTaskShares.forEach((element: any) => {
      if(element[typeId] === item[typeId]){
        item.disabled = true;
      }
    });
  }

  getContacts(){
    let url = 'contacts/access/read';
    let conceptSujetoObligado = this.field.typeConfiguration === 'field-user' && this.concept && this.concept.productId === 'blanqueo' && this.concept.conceptNamedKey === 'SujetoObligado';
    if (this.valueId && !conceptSujetoObligado) {
      if(this.fieldTypeContacts.option === 'Client' || (this.concept && this.concept.conceptNamedKey === 'Cliente')) {
        url = 'contacts/byclientid/' + this.valueId;
      }else{
        url = 'contacts/byevaluationid/' + this.valueId;
      }
    }
    let that = this;
    this.apiService.get(url, 'include-deleted')
      .then((data: any)=> {
        data.map(function (obj: any) {
          obj.type = 'C';
          obj.typeItem = 'contact';
          obj.typeOrder = 3;
          obj.uniqueValueId = 'C-'+obj.contactId;
          if(that.fieldTypeContacts.evaluationTaskShares?.length){
            that.configureItemDisabled(obj, 'contactId');
          }
          return obj;
        });
        let contactsList: any = [];
        if(this.field.typeConfiguration === 'send-sms-certificate'){
          contactsList = this.commonUtilsService.getMobilePhoneList(data, 'phoneNumber1', 'phoneNumber2');
        }else{
          contactsList = this.onlyNotDeleted(data);
        }
        this.fieldTypeContacts.allUsersList = this.fieldTypeContacts.allUsersList.concat(contactsList);
        if(contactsList?.length){
          let state: any = {
            type: 'contact',
            label: this.translate.instant('contacts.contacts'),
            optionAction: 4,
            order: 4,
          }
          this.fieldTypeContacts.typeView.push(state);
        }
        if(this.field.typeCall === 'contacts-only'){
          this.configureTypeView();
          this.checkSelectContact();
        }else if(this.isLanding || this.field.typeCall === 'contacts-users-only'){
          this.getUsers();
        }else{
          this.getRolesUsers();
        }
      }, (errorData:any)=>{
      });
  }

  onlyNotDeleted(data: any){
    return data.filter((item:any) => { return !item.isDeleted });
  }

  getRolesUsers() {
    let productId : any = this.fieldTypeContacts.concept && this.fieldTypeContacts.concept.productId?this.fieldTypeContacts.concept.productId:this.context.settings.defaultProduct;
    let url : any = 'productroles/product/' + productId + '/assignments/notempty';
    if (this.valueId) {
      if(this.field.optionType === 'Client' || (this.concept && this.concept.conceptNamedKey === 'Cliente')) {
        url = 'productroles/product/' + productId + '/client/' + this.valueId + '/assignments/notempty';
      }else{
        url = 'productroles/evaluation/' + this.valueId + '/assignments/notempty';
      }
    }
    let that = this;
    this.apiService.get(url)
      .then((data: any)=> {
        data.map(function (obj: any) {
          obj.type = 'R';
          obj.typeItem = 'productRole';
          obj.typeOrder = 0;
          obj.uniqueValueId = 'R-'+obj.productRoleId;
          obj.fullName = obj.name;
          obj.usersList = '';
          if(that.fieldTypeContacts.evaluationTaskShares?.length){
            that.configureItemDisabled(obj, 'productRoleId');
          }
          let usersList : any =  obj.users.concat(obj.clientsUsers).sort(that.orderListName);
          for(let i=0; i < usersList.length; i ++){
            let user : any = usersList[i];
            obj.usersList+= i===usersList.length-1?user.fullName:user.fullName+', ';
          }
          return obj;
        });
        this.fieldTypeContacts.allUsersList = this.fieldTypeContacts.allUsersList.concat(data);
        if(data?.length){
          let state: any = {
            type: 'productRole',
            label: this.translate.instant('common.roles'),
            optionAction: 1,
            order: 1
          }
          this.fieldTypeContacts.typeView.push(state);
        }
        this.getUsers();
      }, (errorData:any)=>{
      });
  }

  orderListName(a:any, b:any) {
    return a.numOrder < b.numOrder ? 1 : a.numOrder > b.numOrder ? -1 : 0;
  }

  getUsers(){
    let promise : any;
    let conceptSujetoObligado : any = this.field.typeConfiguration === 'field-user' && this.concept && this.concept.productId === 'blanqueo' && this.concept.conceptNamedKey === 'SujetoObligado';
    if(conceptSujetoObligado){
      promise = this.apiService.get('frontusers/only-global-product/'+this.concept.productId, 'include-deleted');
    }else if (this.valueId) {
      if(this.field.typeConfiguration === 'user-role' || this.field.typeConfiguration === 'roles' || this.field.typeCallId === 'productId'){
        promise = this.apiService.get('frontusers/only-product', this.valueId);
      }else if(this.fieldTypeContacts.option === 'Client' || (this.concept && this.concept.conceptNamedKey === 'Cliente')) {
        promise = this.apiService.get('frontusers/byclientid/' + this.valueId, 'include-deleted');
      }else{
        // url = 'frontusers/byevaluationid/' + this.valueId;//'include-deleted'
        promise = this.apiService.get('frontusers/byevaluationid/' + this.valueId, 'include-deleted');
      }
    }else{
      promise = this.apiService.get('frontusers', 'include-deleted');
    }
    let that = this;
    promise.then((data: any)=> {
      data.map(function (obj: any) {
        obj.type = 'U';
        obj.typeItem = 'user';
        obj.typeOrder = 2;
        obj.uniqueValueId = 'U-'+obj.userId;
        if(that.fieldTypeContacts.evaluationTaskShares?.length){
          that.configureItemDisabled(obj, 'userId');
        }
        return obj;
      });
      if(this.field.typeConfiguration === 'confident'){
        for (let i= 0; i<data.length;i++){
          if(data[i].userId === this.context.user.userId){
            data.splice(i,1);
          }
        }
      }else if(this.field.typeConfiguration === 'user-role' && this.field.usersWithRoles){
        this.filterUserRolesExists(data);
      }
      let usersList: any = []
      if(this.field.typeConfiguration === 'send-sms-certificate'){
        usersList = this.commonUtilsService.getMobilePhoneList(data, 'phoneNumber1', 'phoneNumber2');
      }else{
        usersList = this.onlyNotDeleted(data);
      }
      this.fieldTypeContacts.allUsersList = this.fieldTypeContacts.allUsersList.concat(usersList);
      if(usersList?.length){
        let state: any = {
          type: 'user',
          label: this.translate.instant('users-admin.main.user'),
          optionAction: 3,
          order: 3,
        }
        this.fieldTypeContacts.typeView.push(state);
      }
      this.configureTypeView();
      this.checkSelectContact();
      if(this.selectContextUser && this.fieldTypeContacts?.contactListSelected.length === 0){
        this.findContextUser()
      }
      }, (errorData:any)=>{
      });
  }

  findContextUser(){
    let list: any = this.fieldTypeContacts.allUsersList;
    for(var i = 0; i < list.length; i++){
      if(list[i].userId === this.context.user.userId){
        this.addOrDeleteMultipleItem(list[i], 'user');
        break;
      }
    }
  }

  filterUserRolesExists(usersList: any){
    let userIdSelected : any = this.field.selectContacts && this.field.selectContacts[0].userId?this.field.selectContacts[0].userId:undefined;
    for(let i = 0; i < this.field.usersWithRoles.length; i++){
      let userWithRole : any = this.field.usersWithRoles[i];
      for(let j = usersList.length-1; j >= 0; j--){
        let user : any = usersList[j];
        if(userWithRole.userId === user.userId && user.userId !== userIdSelected){
          usersList.splice(j,1);
        }
      }
    }
  }

  configureTypeView(){
    if(this.fieldTypeContacts.typeView?.length > 1){
      let state: any = {
        type: 'all',
        label: this.translate.instant('contacts.all'),
        optionAction: 0,
        order: 0,
      }
      this.fieldTypeContacts.typeView.push(state);
      this.fieldTypeContacts.typeView.sort(this.orderListType);
    }
  }

  orderListType(a:any, b:any) {
    if(a.order > b.order){
      return 1;
    }
    return a.order < b.order ? -1 : 0;
  }

  checkSelectContact() {
    if(this.field.selectContacts){
      this.fieldTypeContacts.contactListSelected = this.field.selectContacts;
    }else if(this.field.typeConfiguration === "field-user" && this.field.evaluatedValue && this.field.evaluatedValue.nvarcharValue){
      this.checkSelectFieldContact();
    }
    this.fieldTypeContacts.contactListSelected.forEach((participantSelected: any)=>{
      let type : any ='';
      if(participantSelected.type === 'U' || this.field.typeConfiguration === 'roles' || this.field.typeConfiguration === 'user-role'){
        type='user';
      }else if(participantSelected.type === 'C'){
        type='contact';
      }else if(participantSelected.type === 'G'){
        type='group';
      }else{
        type='productRole';
      }
      if(!participantSelected[type+'Id'] && participantSelected.type && participantSelected.id){
        participantSelected[type+'Id'] = participantSelected.id;
      }else if(participantSelected.taskParticipantId && !participantSelected[type+'Id']){
        participantSelected[type+'Id'] = participantSelected.taskParticipantId;
      }
      this.fieldTypeContacts.allUsersList.forEach((participantByTypeList: any)=>{
        if(type === participantByTypeList.typeItem && (participantSelected[type+'Id'] === participantByTypeList[type+'Id'] || participantSelected.id === participantByTypeList[type+'Id'])){
          participantByTypeList.active = true;
          participantSelected.fullName = participantByTypeList.fullName;
          participantSelected.listValueId = participantByTypeList[type+'Id'];
          participantSelected.typeName = type;
          participantSelected.isDeleted = participantByTypeList.isDeleted;
          if(this.field.typeConfiguration === "field-user" || this.field.typeConfiguration === "roles"){
            participantSelected.email = participantByTypeList.email;
            participantSelected.phoneNumber1 = participantByTypeList.phoneNumber1;
            if(this.field.typeConfiguration === "field-user"){
              this.configureDisplayDataList(participantSelected);
            }
          }
          participantSelected.active = true;
        }
      })
    })
    this.configureDisabledList();
  }

  checkSelectFieldContact(){
    if (this.field.evaluatedValue.nvarcharValue.indexOf('|') !==-1) {
      this.fieldTypeContacts.selectedUsersFields = this.field.evaluatedValue.nvarcharValue.split('|');
      this.fieldTypeContacts.selectedUsersFields.forEach((selectedUser: any)=>{
        this.configurateUserFieldSelected(selectedUser);
      })
    } else{
      this.configurateUserFieldSelected(this.field.evaluatedValue.nvarcharValue);
    }
  }

  configurateUserFieldSelected(participantSelected: any){
    let typeOption : any = participantSelected.split('-');
    let typeId : any = typeOption[1]==='role'?'productRole':typeOption[1];
    let contactListSelected : any = {
      type: typeOption[1].substr(0,1).toUpperCase(),
      [typeId+'Id']: parseInt(typeOption[0])
    }
    this.fieldTypeContacts.contactListSelected.push(contactListSelected);
  }

  changeView(selectedView: any){
    // this.fieldTypeContacts.selectedView = selectedView === this.fieldTypeContacts.selectedView.type?'all':selectedView;
    this.fieldTypeContacts.selectedView = selectedView === this.fieldTypeContacts.selectedView.type?this.fieldTypeContacts.typeView[0]:selectedView;
    this.fieldTypeContacts.showToggleAll = this.showToggleAll();
  }

  showToggleAll(){
    if(this.field.multiple){
      let allUsersList: any = this.commonUtilsService.findByWord(this.fieldTypeContacts.allUsersList, this.fieldTypeContacts.searchName, ['fullName']);
      if(this.fieldTypeContacts.selectedView?.type === 'all'){
        return allUsersList?.length > 10;
      }else{
        let participantType: any = [];
        allUsersList.forEach((participant: any) => {
          if(participant.typeItem === this.fieldTypeContacts.selectedView.type){
            participantType.push(participant);
          }
        });
        return participantType.length > 10;
      }
    }else{
      return false;
    }
  }

  changeList(){
    this.fieldTypeContacts.showToggleAll = this.showToggleAll();
  }

  openContactList(){
    this.fieldTypeContacts.showSigned = false;
    if(!this.field.noEditable){
      this.contactsClosed.emit({type:'open'});
    }
  }

  openModalRelatedInfo(fieldRelatedInfo:any){
    this.openRelatedInfo.emit({relatedInfo:fieldRelatedInfo});
  }

  resetSearch(){
    this.fieldTypeContacts.searchName = '';
  }

  addNewContact(){
    let configuration: any = {
      option: this.fieldTypeContacts.option,
      valueId: this.fieldTypeContacts.originalValueId
    };
    this.modalService.newContact(configuration)
      .subscribe((result:any) => {
        if(result.result === 'ok'){
          this.fieldTypeContacts.allUsersList.push(result.newContact);
          if(!this.checkTypeExist('contact')){
            let state: any = {
              type: 'contact',
              label: this.translate.instant('contacts.contacts'),
              optionAction: 4,
              order: 4,
            }
            this.fieldTypeContacts.typeView.push(state);
          }
          this.configureTypeView();
          this.selectItem(result.newContact, 'contact');
          this.fieldTypeContacts.showToggleAll = this.showToggleAll();
          // let buttonOpenList: any = $('button-overlay-contacts-field-'+this.field.id)
          // buttonOpenList.click();
          // this.fieldTypeContactsOverlay.show('', this.containerFieldContactElement.nativeElement);
        }
      });
  }

  checkTypeExist(type: string){
    for(let i = 0; i < this.fieldTypeContacts.typeView.length; i++){
      if(this.fieldTypeContacts.typeView[i].type === type){
        return true;
      }
    }
    return false;
  }

  configureListUsersSelected(){
    let nvarcharValue : any ='';
    for(let i = 0; i < this.fieldTypeContacts.contactListSelected.length; i++){
      let contactSelected : any = this.fieldTypeContacts.contactListSelected[i];
      if(this.fieldTypeContacts.contactListSelected.length-1 === i){
        if(contactSelected.listValueId){
          nvarcharValue += contactSelected.listValueId+'-'+contactSelected.typeName;
        }
      }else{
        if(contactSelected.listValueId){
          nvarcharValue += contactSelected.listValueId+'-'+contactSelected.typeName+'|';
        }
      }
    }
    this.sendContacts.emit({newValue: nvarcharValue});
  }

  configureAssists(){
    this.fieldTypeContacts.all = 0;
    this.fieldTypeContacts.pending = 0;
    this.fieldTypeContacts.confirm = 0;
    this.fieldTypeContacts.cancel = 0;
    this.field.selectContacts.forEach((participant:any) => {
      if(participant.assists === null || participant.assists === undefined){
        this.fieldTypeContacts.pending++;
      }else if(participant.assists === true || participant.assists === 1){
        this.fieldTypeContacts.confirm++;
      }else if(participant.assists === false || participant.assists === 0){
        this.fieldTypeContacts.cancel++;
      }
    });
    this.fieldTypeContacts.all = this.field.selectContacts.length;
  }

  configureDisplayDataList(contact: any){
    if(this.field && this.field.fieldTypeId === 'user'){
      let newContact : any = {
        id: contact.listValueId,
        idType: contact.type,
        value:{
          name: contact.fullName,
          mail: contact.email,
          phone: contact.phoneNumber1,
        }
      };
      this.field.evaluatedValue.displayData.push(newContact);
    }
  }

  setDisabledContacts(list:any){
    list.forEach((itemSelected:any) => {
      itemSelected.disabled = false;
      this.listDisabled.forEach((listDisabled:any) => {
        let listDisabledId : any = listDisabled.uniqueValueId?listDisabled.uniqueValueId:listDisabled.type+'-'+listDisabled.id;
        if(!itemSelected.active && itemSelected.uniqueValueId === listDisabledId){
          itemSelected.disabled = true;
        }
      });
    });
  }

  addOrDeleteMultipleItem(participant: any, type: any){
    if(!participant.disabled){
      if(!this.fieldTypeContacts.contactListSelected){
        this.fieldTypeContacts.contactListSelected = [];
      }
      let addToList = true;
      participant.listValueId = participant[type+'Id'];
      for(let i = 0; i < this.fieldTypeContacts.contactListSelected.length; i++){
        if(participant.listValueId === this.fieldTypeContacts.contactListSelected[i][type + 'Id']){
          this.fieldTypeContacts.markAll = false;
          participant.active = false;
          this.fieldTypeContacts.contactListSelected.splice(i, 1);
          if(this.field.typeConfiguration === 'field-user'){
            this.field.evaluatedValue.displayData.splice(i, 1);
          }
          this.fieldTypeContacts.allUsersList.forEach((typeItem: any)=>{
            if(typeItem[type+'Id'] === participant.listValueId){
              this.fieldTypeContacts.markAll = false;
              typeItem.active = false;
            }
          })
          addToList = false;
          break;
        }
      }
      if(addToList){
        participant.active = true;
        participant.typeName = type==='productRole'?'role':type;
        this.fieldTypeContacts.contactListSelected.push(participant);
        this.configureDisplayDataList(participant);
      }
      if(this.field.typeConfiguration === "field-user"){
        this.configureListUsersSelected();
      }else{
        this.sendContacts.emit({contacts:this.fieldTypeContacts.contactListSelected});
      }
      if(this.field){
        this.field.error = false;
      }
      if(this.field.selectContacts && this.field.typeConfiguration === 'meeting'){
        this.configureAssists();
      }
    }
  }

  toggleAll() {
    this.fieldTypeContacts.markAll = !this.fieldTypeContacts.markAll;
    if(this.fieldTypeContacts.searchName){
      let usersListFiltered: any = this.commonUtilsService.findByWord(this.fieldTypeContacts.allUsersList, this.fieldTypeContacts.searchName, ['fullName'])
      this.fieldTypeContacts.allUsersList.forEach((item: any)=>{
        for(let i = 0; i < usersListFiltered.length; i++){
          let userListFiltered: any = usersListFiltered[i];
          if (item[item.typeItem+'Id'] === userListFiltered[item.typeItem+'Id'] && item.active !== this.fieldTypeContacts.markAll && (this.fieldTypeContacts.selectedView.type === 'all' || this.fieldTypeContacts.selectedView.type === item.typeItem)) {
            this.addOrDeleteMultipleItem(item, item.typeItem);
            break;
          }
        }
      })
    }else{
      this.fieldTypeContacts.allUsersList.forEach((item: any)=>{
        if (item.active !== this.fieldTypeContacts.markAll && (this.fieldTypeContacts.selectedView.type === 'all' || this.fieldTypeContacts.selectedView.type === item.typeItem)) {
          this.addOrDeleteMultipleItem(item, item.typeItem);
        }
      })
    }
  }

  selectSign(type: any, e: any){
    this.field.selectContacts.forEach((listAssists: any)=>{
      if(listAssists.assists === null || listAssists.assists === undefined){
        listAssists.color = 'grey';
      }else if(listAssists.assists === true || listAssists.assists === 1){
        listAssists.color = 'green';
      }else if(listAssists.assists === false || listAssists.assists === 0){
        listAssists.color = 'red';
      }
    });
    this.fieldTypeContacts.participantList = [];
    switch(type){
      case 'all':
        this.fieldTypeContacts.selectedSign = {title: this.translate.instant('contacts.state-all')}
        this.fieldTypeContacts.participantList = this.field.selectContacts;
        break;
      case 'confirm':
        this.fieldTypeContacts.selectedSign = {title: this.translate.instant('contacts.state-confirm')};
        this.addParticipants({ value1: 1, value2: true});
        break;
      case 'cancel':
        this.fieldTypeContacts.selectedSign = {title: this.translate.instant('contacts.state-cancel')};
        this.addParticipants({ value1: 0, value2: false});
        break;
      case 'pending':
        this.fieldTypeContacts.selectedSign = {title: this.translate.instant('contacts.state-pending')};
        this.addParticipants({ value1: null, value2: undefined});
        break;
      default:
        this.fieldTypeContacts.participantList = this.field.selectContacts;
        break;
    }
    this.fieldTypeContacts.selectAssists = this.fieldTypeContacts.participantList.length;
    if(this.listInDropdownComponent.dropdown?.overlayVisible){
      this.listInDropdownComponent.toggleMenu(e);
    }
    this.listInDropdownComponent.toggleMenu(e);
  }

  addParticipants(typeAssists: any){
    this.field.selectContacts.forEach((selectContacts: any) => {
      if(selectContacts.assists === typeAssists.value1 || selectContacts.assists === typeAssists.value2){
        this.fieldTypeContacts.participantList.push(selectContacts);
      }
    });
  }

  selectItem(item: any, type: any) {
    if (this.field.multiple) {
      this.addOrDeleteMultipleItem(item, type);
    } else {
      this.addSimpleItem(item, type);
    }
  }

  addSimpleItem(participant: any, type: any){
    if(!participant.disabled){
      this.fieldTypeContacts.allUsersList.forEach((participantElement: any) => {
        participantElement.active = false;
      });
      participant.active = true;
      participant.listValueId = participant[type+'Id'];
      this.fieldTypeContacts.contactListSelected = [participant];
      this.fieldTypeContacts.showList = false;
      this.fieldTypeContactsOverlay.hide();
      if(this.field.typeConfiguration === "field-user"){
        let typeId = type === 'productRole'?'role':type;
        let newContact = this.fieldTypeContacts.contactListSelected[0].listValueId + '-'+ typeId;
        this.field.evaluatedValue.displayData = [];
        this.configureDisplayDataList(participant);
        this.sendContacts.emit({newValue: newContact});
      }else{
        this.sendContacts.emit({contacts:this.fieldTypeContacts.contactListSelected});
      }
      if(this.field){
          this.field.error = false;
      }
    }
  }

  // openOverlay(){
  //   this.fieldTypeContacts.selectedView = this.fieldTypeContacts.typeView[0];
  //   this.fieldTypeContacts.showToggleAll = this.showToggleAll();
  //   this.fieldTypeContacts.showList = true;
  //   if(this.isLanding && window.innerWidth <= 767){
  //     this.fieldTypeContacts.littleDesignTypeView = true;
  //     this.fieldTypeContacts.configuratedDesignTypeView = true;
  //   }else{
  //     setTimeout(() => {
  //       let heightTypeView: any = document.getElementById('typeViewContactBlock-'+this.field.id);
  //       if(heightTypeView.offsetHeight > 33){
  //         this.fieldTypeContacts.littleDesignTypeView = true;
  //       }else{
  //         this.fieldTypeContacts.littleDesignTypeView = false;
  //       }
  //       this.fieldTypeContacts.configuratedDesignTypeView = true;
  //     }, 200);
  //   }
  // }

  openOverlay() {

  // Filtra duplicados por `type`, elimina duplicados en typeview

  const uniqueTypes = new Set();
  this.fieldTypeContacts.typeView = this.fieldTypeContacts.typeView.filter((item: any) => {
    if (uniqueTypes.has(item.type)) return false;
    uniqueTypes.add(item.type);
    return true;
  });

  this.fieldTypeContacts.selectedView = this.fieldTypeContacts.typeView[0];
  this.fieldTypeContacts.showToggleAll = this.showToggleAll();
  this.fieldTypeContacts.showList = true;

  if (this.isLanding && window.innerWidth <= 767) {
    this.fieldTypeContacts.littleDesignTypeView = true;
    this.fieldTypeContacts.configuratedDesignTypeView = true;
  } else {
    setTimeout(() => {
      const heightTypeView: any = document.getElementById('typeViewContactBlock-' + this.field.id);
      this.fieldTypeContacts.littleDesignTypeView = heightTypeView.offsetHeight > 33;
      this.fieldTypeContacts.configuratedDesignTypeView = true;
    }, 200);
  }
}

  closeOverlay(){
    this.fieldTypeContacts.showList = false;
    delete this.fieldTypeContacts.littleDesignTypeView;
    delete this.fieldTypeContacts.configuratedDesignTypeView;
  }

  toggleFilter(e: any){
    this.commonUtilsService.toggleFilterOverlay(e, this.fieldTypeContactsOverlay, 'overlay', this.containerFieldContactElement.nativeElement);
  }

  ngOnDestroy(){
    this.commonUtilsService.OnDestroy(this.subscribers);
  }
}
